/**
 * W15 — REPL 输出区
 *
 * 管理 #output-panel 的内容追加与状态控制。
 * setRunning 通过自定义事件通知 main.js，避免与 DOM 结构耦合。
 */

const panel = () => document.getElementById('output-scroll');

/** 追加普通输出行。 */
export function appendOutput(text) {
  const el = panel();
  if (!el) { console.log('[output]', text); return; }
  const line = document.createElement('div');
  line.className = 'output-line';
  line.textContent = text;
  el.appendChild(line);
  el.scrollTop = el.scrollHeight;
}

/** 追加错误行（红色，带"错误: "前缀）。 */
export function appendError(text) {
  const el = panel();
  if (!el) { console.error('[error]', text); return; }
  const line = document.createElement('div');
  line.className = 'output-error';
  line.textContent = '错误: ' + text;
  el.appendChild(line);
  el.scrollTop = el.scrollHeight;
}

/**
 * 追加代码历史记录（REPL >> 前缀）。
 * 首行前缀为 ">> "，续行前缀为 "   "（与首行对齐）。
 * 空白输入不追加。
 */
export function appendCode(code) {
  const trimmed = code.trim();
  if (!trimmed) return;
  const el = panel();
  if (!el) return;
  trimmed.split('\n').forEach((line, i) => {
    const div = document.createElement('div');
    div.className = 'output-code';
    div.textContent = (i === 0 ? '>> ' : '   ') + line;
    el.appendChild(div);
  });
  el.scrollTop = el.scrollHeight;
}

/** 清空输出面板。 */
export function clearOutput() {
  const el = panel();
  if (el) el.innerHTML = '';
}

/**
 * 切换"执行中"状态。
 * 通过自定义事件 ty:running 通知 main.js 更新工具栏。
 */
export function setRunning(running) {
  document.dispatchEvent(new CustomEvent('ty:running', { detail: { running } }));
}
